// Real PickQuick image mapping for the landing page.
// These URLs point to Indian quick-commerce / warehouse imagery shared by the team.

export const mediaSections = {
  belowHeroBanner: {
    id: "below-hero",
    alt: "PickQuick warehouse team handling cartons inside an Indian motherhub warehouse",
    url:
      "",
  },
  howItWorksWarehouse: {
    id: "how-it-works-warehouse",
    alt: "Indian dark store with aisles of racks and teams picking inventory",
    url:
      "",
  },
  whatWeDoStrip: [
    {
      id: "strip-warehouse",
      alt: "High shelves of cartons with Indian teams scanning SKUs in a warehouse aisle",
      url:
        "",
    },
    {
      id: "strip-dispatch",
      alt: "Night operations with PickQuick boxes being sorted for dispatch in a dark store",
      url:
        "",
    },
    {
      id: "strip-scanning",
      alt: "Close-up of Indian operations team handling orders in a packed warehouse floor",
      url:
        "",
    },
  ],
  advantageImages: [
    {
      id: "adv-agent",
      alt: "PickQuick team in brand t-shirts managing cartons during night operations",
      url:
        "",
    },
    {
      id: "adv-darkstore",
      alt: "PickQuick warehouse staff in green uniforms stocking cartons on racks",
      url:
        "",
    },
  ],
  footerDispatch: {
    id: "footer-dispatch",
    alt: "Dispatch bay with PickQuick-branded cartons and warehouse team in India",
    url:
      "",
  },
};

export const brandLogos = [
  {
    id: "souled-store",
    name: "The Souled Store",
    url:
      "/assets/logos/souled-store.webp",
  },
  {
    id: "nandini",
    name: "Nandini",
    url:
      "/assets/logos/nandini.webp",
  },
  {
    id: "aavin-dairy",
    name: "Aavin Dairy",
    url:
      "/assets/logos/aavin-dairy.webp",
  },
  {
    id: "goldie-masala",
    name: "Goldie Masala",
    url:
      "/assets/logos/goldie-masala.webp",
  },
  {
    id: "prakash-masala",
    name: "Prakash Masala",
    url:
      "/assets/logos/prakash-masala.webp",
  },
  {
    id: "d-decor",
    name: "D'Decor",
    url:
      "/assets/logos/d-decor.webp",
  },
  {
    id: "keerthi-nirmal",
    name: "Keerthi Nirmal",
    url:
      "/assets/logos/keerthi-nirmal.webp",
  },
  {
    id: "vasant",
    name: "Vasant",
    url:
      "/assets/logos/vasant.webp",
  },
  {
    id: "ilem-japan",
    name: "ILEM Japan",
    url:
      "/assets/logos/ilem-japan.webp",
  },
  {
    id: "siddhivinayak",
    name: "Shree Siddhivinayak Pickles and Masala",
    url:
      "/assets/logos/siddhivinayak.webp",
    // Asset arrives tightly cropped; add extra internal padding so its optical
    // weight matches the other cards rather than bleeding to the card edge.
    extraPadding: true,
  },
];
